import humps from 'lodash-humps-ts';
import { omit } from 'lodash';
import { snakes } from '@utils/lodash';
import { authAxios } from '@components/Auth';
import { InsuranceTypes } from '@models/InsuranceType';
import { CarClaim } from '@models/CarClaim';
import { API_V1_BASE } from '@config';
import { PaymentInfo } from '@models/PaymentInfo';

export interface CreateCarClaimParams {
  carOrderId: number;
  insuranceType: InsuranceTypes;
  claimTypes: string[];
  accidentHappenedAt: string;
  accidentPhotos: File[];
  passengersAndThirdPartiesPoliceReports: File[];
  supportingDocuments: File[];
  totalClaimedAmount: number;
  acceptTermsAndConditions: boolean;
  mobileNumber: string;
  email?: string;
  paymentInfo: PaymentInfo;
}

export interface GetCarClaimParams {
  carClaimId: number;
}

export class CarClaimApi {
  static create = async ({ paymentInfo, ...rest }: CreateCarClaimParams) => {
    return await authAxios
      .postForm(`${API_V1_BASE}/user/car_claims`, {
        ...omit(snakes(rest), [
          'accident_photos',
          'passengers_and_third_parties_police_reports',
          'supporting_documents',
          'claim_types',
        ]),
        'payment_info[payment_method]': paymentInfo.paymentMethod,
        'payment_info[bank_name]': paymentInfo.bankName,
        'payment_info[beneficiary_name]': paymentInfo.beneficiaryName,
        'payment_info[bank_account]': paymentInfo.bankAccount,
        'accident_photos[]': rest.accidentPhotos,
        'passengers_and_third_parties_police_reports[]': rest.passengersAndThirdPartiesPoliceReports,
        'supporting_documents[]': rest.supportingDocuments,
        'claim_types[]': rest.claimTypes,
      })
      .then((response) => humps(response.data) as CarClaim);
  };

  static get = async (params: GetCarClaimParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/car_claims/${params.carClaimId}`)
      .then((response) => humps(response.data) as CarClaim);
  };
}
